import Button, { ButtonSize, ButtonStyle } from 'components/common/Button';
import RoundedButton from 'components/RoundedButton';
import { useCtaButtonTextAndHref } from 'hooks/cta/useCtaButtonTextAndHref';
import { observer } from 'mobx-react-lite';

import styles from './EnterButton.module.css';

interface Props {
  dm2026Button?: boolean;
  overrideButtonText?: string;
  overrideReferralText?: boolean;
  buttonStyle?: ButtonStyle;
  buttonSize?: ButtonSize;
  buttonFullWidth?: boolean;
  skipLoadedCheck?: boolean;
  minWidth?: number;
}

/** A button that takes the user to the first page of the enter flow. Its text and destination depend on the referral
 * flow, the user's subscription tier and the SkipChooseYourPlan2026 AB test - see useCtaButtonTextAndHref.
 */
export const EnterButton = observer(
  ({
    dm2026Button,
    overrideButtonText,
    overrideReferralText,
    buttonStyle,
    buttonSize,
    buttonFullWidth,
    skipLoadedCheck,
    minWidth,
  }: Props) => {
    const { text, href, onClick, hidden, isLoaded } = useCtaButtonTextAndHref({
      overrideText: overrideButtonText,
      overrideTextInReferralFlow: overrideReferralText,
    });

    if ((!skipLoadedCheck && !isLoaded) || hidden) {
      return null;
    }

    if (dm2026Button) {
      return (
        <Button
          buttonStyle={buttonStyle ?? 'Primary'}
          buttonSize={buttonSize ?? 'Medium'}
          onClick={onClick}
          href={href}
          fullWidth={buttonFullWidth ? true : 'flex1'}
          minWidth={minWidth}
        >
          {text}
        </Button>
      );
    }

    return (
      <span className={styles.ctaButton}>
        <RoundedButton
          href={href}
          onClick={onClick}
          rebrandDm2025
          colorStyle="Primary"
          fullWidth
        >
          {text}
        </RoundedButton>
      </span>
    );
  },
);
